// Shared API client for the CargoFlow web app.
// Uses the SAME FastAPI backend and JWT as the mobile app.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const baseUrl = String(BACKEND_URL || "").replace(/\/$/, "");

export const TOKEN_KEY = "cargoflow.auth.token";
export const ADMIN_TOKEN_KEY = "cargoflow.admin.token";
export const IMPERSONATION_TOKEN_KEY = "cargoflow.impersonation.token";

export function getToken() {
  try {
    // In modalità "Visualizza come utente" l'app operativa usa il token temporaneo di impersonazione
    return window.localStorage.getItem(IMPERSONATION_TOKEN_KEY) || window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}
export function saveAuthToken(token) {
  window.localStorage.setItem(TOKEN_KEY, token);
}
export function clearAuthToken() {
  window.localStorage.removeItem(TOKEN_KEY);
}

export function getImpersonationToken() {
  try {
    return window.localStorage.getItem(IMPERSONATION_TOKEN_KEY);
  } catch {
    return null;
  }
}
export function saveImpersonationToken(token) {
  window.localStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
}
export function clearImpersonationToken() {
  window.localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
}

export function getAdminToken() {
  try {
    return window.localStorage.getItem(ADMIN_TOKEN_KEY);
  } catch {
    return null;
  }
}
export function saveAdminToken(token) {
  window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
}
export function clearAdminToken() {
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
}

async function request(token, path, options = {}) {
  const response = await fetch(`${baseUrl}/api${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.detail || "Si è verificato un errore. Riprova.");
  }
  return payload;
}

export function apiFetch(path, options = {}) {
  return request(getToken(), path, options);
}

export function adminFetch(path, options = {}) {
  return request(getAdminToken(), path, options);
}

export async function apiUpload(path, file) {
  const token = getToken();
  const form = new FormData();
  form.append("file", file, file.name);
  const response = await fetch(`${baseUrl}/api${path}`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.detail || "Caricamento non riuscito. Riprova.");
  return payload;
}

export function fileUrl(attachmentId) {
  const token = getToken();
  return `${baseUrl}/api/files/${attachmentId}?token=${encodeURIComponent(token || "")}`;
}

export function adminFileUrl(attachmentId) {
  const token = getAdminToken() || getToken();
  return `${baseUrl}/api/files/${attachmentId}?token=${encodeURIComponent(token || "")}`;
}
